export default __webpack_public_path__ + "static/media/7t.0bb7c1e3.jpg";